import { useState } from "react";
import "../css/Login.css";
import { useNavigate } from "react-router-dom";
import { requestWithHeaders } from "../api/requestMethods";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { BeatLoader } from "react-spinners";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const userLogin = async () => {
    setLoading(true);
    try {
      const res = await requestWithHeaders.post("/api/user/login", {
        email,
        password,
      });
      localStorage.setItem("token", res?.data?.data?.token);
      setLoading(false);
      navigate("/");
    } catch (err) {
      console.log(err);
      setLoading(false);
      toggleModal();
    }
    setLoading(false);
  };

  return (
    <div className="background">
      <div className="card h-10 w-10">
        <div className="card-body login-card p-5">
          <div className="row mt-1 mx-5">
            <div className="mb-3" style={{ fontSize: 14 }}>
              Email
            </div>
            <div className="input-group flex-nowrap">
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                aria-label="email"
                aria-describedby="addon-wrapping"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="row mt-3 mx-5">
            <div className="mb-3" style={{ fontSize: 14 }}>
              Password
            </div>
            <div className="input-group flex-nowrap">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Password"
                aria-label="Password"
                aria-describedby="addon-wrapping"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                style={{ paddingRight: "40px", borderRadius: "10px" }} // Add padding to accommodate the icon
              />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>

            <button
              className="btn btn-login mt-5"
              disabled={loading}
              onClick={userLogin}
            >
              {!loading ? (
                "Login"
              ) : (
                <BeatLoader size={8} color="#fff" margin={2} />
              )}
            </button>
          </div>
        </div>
      </div>
      {modal && (
        <div className="notification-modal">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="notification-modal-content p-5">
            <h2>ERROR!!</h2>
            <p>Invalid Username or Password!</p>
            <button className="close-modal" onClick={toggleModal}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="black"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </button>
            <div className="modal-footer" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
